module.exports = __webpack_public_path__ + "img/icb-opening-02.b7127b47.png";